import { File as FilesIcon, FolderPlus, Plus, Upload } from '@ondit/ui'
import { type ChromeActionSpec, ResourceChromeFallback } from '@/screens/workspace/components'
import { useT } from '~/core/i18n'

const COLUMNS = [
  { id: 'name', header: 'Name', widthMultiplier: 1.15 },
  { id: 'size', header: 'Size', widthMultiplier: 0.85 },
  { id: 'type', header: 'Type', widthMultiplier: 1.0 },
  { id: 'created', header: 'Created' },
  { id: 'owner', header: 'Owner' },
  { id: 'updated', header: 'Last Updated' },
]

const ACTIONS: ChromeActionSpec[] = [
  { text: 'Upload', icon: Upload },
  { text: 'New folder', icon: FolderPlus },
  { text: 'New file', icon: Plus, variant: 'primary' },
]

export default function FilesLoading() {
  const t = useT()
  return (
    <ResourceChromeFallback
      icon={FilesIcon}
      title={t('Files')}
      columns={COLUMNS.map((column) => ({ ...column, header: t(column.header) }))}
      actions={ACTIONS.map((action) => ({ ...action, text: t(action.text) }))}
      searchPlaceholder={t('Search files...')}
      hasSort
      hasFilter
    />
  )
}
